import React, { useState } from "react";
import { Formik, useField} from "formik";
import * as yup from "yup";
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Card,
  Typography,
  MenuItem,
  FormHelperText,
  InputLabel,
  FormControl,
  Select,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import swal from "sweetalert";
import Swal from 'sweetalert2';
import { toast, ToastContainer } from "react-toastify";
import imageCompression from 'browser-image-compression';
import { PDFDocument } from 'pdf-lib';
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useAuth } from '../../../AuthProvider';
import {  IconButton } from "@mui/material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
// Define styled components
const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const FacebookCircularProgress = styled(CircularProgress)({
  color: "#3b5998",
});




const PrincipalRoleRegistrations = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const navigate=useNavigate()
  const { userId,oId ,pId,pricipalEmailId,triggerRefresh ,feature,plan} = useAuth(); // Access userId from AuthContext
  const baseUrl=process.env.REACT_APP_API_BASE_URL

  // Validation schema using yup
  const validationSchemaTab0 = yup.object().shape({
    // Basic Details
    // prefix: yup.string().required("Prefix is required"),
    firstName: yup
      .string()
      .required("First Name is required")
      .matches(/^[a-zA-Z\s]+$/, "First Name can only contain letters"),
    lastName: yup
      .string()
      .required("Last Name is required")
      .matches(/^[a-zA-Z\s]+$/, "Last Name can only contain letters"),
      emailId: yup
      .string()
      .email("Invalid email format")
      .required("Email is required"),
    // contactNumber: yup
    //   .string()
    //   .required("Contact Number is required")
    //   .matches(/^\d+$/, "Contact Number can only contain numbers")
    //   .matches(/^[0-9]{10}$/, "Contact Number must be exactly 10 digits"),

   
    // role: yup.string().required("Role is required"),
    userRoleName: yup.string().required("Role is required"),
  //   userRoleName: yup.string()
  // .oneOf([
  //   "ADMISSION_FEE", 
  //   "HRBP", 
  //   "SCHEDULE_MEETING", 
  //   "EXAMINATION_CELL",
  //   "TRANSPORT",
  //   "STORE_DEPARTMENT"
  // ])
  // .required("Role is required"),

    // profilePic: yup
    // .mixed()
    // .required("Profile picture is required")
    // .test("fileSize", "File size should be less than 1MB", (value) => {
    //   return value && value.size <= 1024 * 1024; // 1MB in bytes
    // })
    // .test("fileFormat", "Unsupported file format. Only JPG, JPEG, and PNG are allowed", (value) => {
    //   return value && ["image/jpeg", "image/jpg", "image/png"].includes(value.type);
    // }),

    
  });

 

  const getValidationSchema = () => {
    switch (currentTab) {
      case 0:
        return validationSchemaTab0;
      // Add cases for other tabs if needed
      default:
        return validationSchemaTab0; // Default schema
    }
  };
  
  
  
  
  //  new handle submit code
  const handleSubmit = async (values) => {
    // Show confirmation dialog
    const result = await Swal.fire({
      title: `Add ${values.userRoleName}`,
      text: `Are you sure you want to Register ${values.userRoleName} Role.`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    });
  
    if (result.isConfirmed) {
      setLoading(true);
      try {
        // 
        const sanitizedValues = { ...values };
        Object.keys(sanitizedValues).forEach((key) => {
          if (sanitizedValues[key] === '' || sanitizedValues[key] === 'null') {
            sanitizedValues[key] = null;
          }
        });
  
        const formData = new FormData();
  
        // Function to compress files
        const compressFile = async (file) => {
          if (!file) return file;
  
          if (file.type.startsWith('image/')) {
            // Compress image file
            const options = { maxSizeMB: 1, maxWidthOrHeight: 1024 };
            return await imageCompression(file, options);
          } else if (file.type === 'application/pdf') {
            // Compress PDF file
            const pdfDoc = await PDFDocument.load(await file.arrayBuffer());
            const compressedPdf = await pdfDoc.save();
            return new Blob([compressedPdf], { type: 'application/pdf' });
          }
          return file;
        };
  
        // Function to handle and append files
        const handleFile = async (key, file) => {
          const compressedFile = await compressFile(file);
          formData.append(key, compressedFile);
        };
  
        // Append files and other values to FormData
        await Promise.all(
          Object.keys(sanitizedValues).map(async (key) => {
            if (sanitizedValues[key] && sanitizedValues[key] instanceof File) {
              await handleFile(key, sanitizedValues[key]);
            } else if (sanitizedValues[key] !== null) {
              formData.append(key, sanitizedValues[key]);
            }
          })
        );
  
        const apiEndpoint = `${baseUrl}/api/principal/saveStaffLoginUsers/${pId}`;
       

        // Make the API call
        const response = await fetch(apiEndpoint, {
          method: 'POST',
          body: formData,
        });

        const responseData = await response.json();
        if (response.ok) {
          // ✅ Stop loading before toast appears
          setLoading(false);
          await new Promise((resolve) => {
            toast.success(`${values.userRoleName} Role Registered Successfully`, {
              position: "top-right",
              autoClose: 1000,
              onClose: resolve,
            });
          });
          navigate(-1);
          // Refresh roles list
          // setRefreshKey((prev) => prev + 1);
           triggerRefresh("registeredRoles"); // only re-fetch quiz types

          
        } else {
          const errorMessage = responseData?.error_message || "Error submitting the form.";
          toast.error(errorMessage, { position: "top-right", autoClose: 2000 });
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("An unexpected error occurred. Please try again.", {
          position: "top-right",
          autoClose: 2000,
        });
      } finally {
        setLoading(false);
      }
    }
  };



  // Initial form values
  
  const allRoles = [
    { value: "ADMISSION_FEE", label: "ADMISSION_FEE" },
    { value: "EXAMINATION_CELL", label: "EXAMINATION_CELL" },
    { value: "SCHEDULE_MEETING", label: "SCHEDULE_MEETING" },
    { value: "TRANSPORT", label: "TRANSPORT" },
    { value: "HRBP", label: "HRBP" },
    { value: "STORE_DEPARTMENT", label: "STORE_DEPARTMENT" },
  ];
  
  const featureRoleMap = {
    LITE: ["ADMISSION_FEE", "HRBP", "EXAMINATION_CELL","SCHEDULE_MEETING"],
    CORE: [
      "ADMISSION_FEE",
      "HRBP",
      "EXAMINATION_CELL",
      "SCHEDULE_MEETING",
      "TRANSPORT",
      "STORE_DEPARTMENT",
    ],
    ULTRA: [
      "ADMISSION_FEE",
      "HRBP",
      "EXAMINATION_CELL",
      "SCHEDULE_MEETING",
      "TRANSPORT",
      "STORE_DEPARTMENT",
    ], // all roles
  };
  

  const visibleRoles = allRoles.filter((role) =>
    featureRoleMap[feature]?.includes(role.value)
  );
  


  
  
  const initialValues = {
   
    firstName: "",
    lastName: "",
    emailId: pricipalEmailId,
    contactNumber: "",
    gender: "",
    role:"STAFF_LOGIN_USERS",
    userRoleName:'',
    //Documents
    profileUser: null,
  };

  

  return (
    <Box marginTop={9}>

     
      <Formik
        initialValues={initialValues}
        validationSchema={getValidationSchema()}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          validateForm,
          setFieldValue,
          setTouched,
        }) => (
          <form
            onSubmit={(e) => {
              e.preventDefault(); // Prevent the default form submission behavior
              handleSubmit(values); // Call the handleSubmit function with form values
            }}
          >
            <Box display="flex" flexDirection="column" alignItems="center">
              <Card
                sx={{
                  padding: 2,
                  backgroundColor: "#fff",
                  width: "96%",
                  height: "60%",
                }}
              >
                 
                {currentTab === 0 && (
                  <Box>
                    

<Box display="flex" alignItems="center" sx={{marginBottom:2}}>
                              <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
                                <KeyboardBackspaceIcon fontSize="medium" />
                              </IconButton>
                              <Typography variant="h4" component="h3" sx={{fontWeight:'bold' }}>
                              Department Registrations
                              </Typography>
                            </Box>


                    <Box
                      display="grid"
                      gap="30px"
                      gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                    >

<StyledTextField
                        fullWidth
                        type="email"
                        label="Principal Email"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={pricipalEmailId}
                        name="emailId"
                        autoComplete="off"
                        error={!!touched.emailId && !!errors.emailId}
                        helperText={touched.emailId && errors.emailId}
                        disabled
                        InputProps={{
                          style: {
                            backgroundColor: "#f0f0f0",
                            color: "#6c757d",
                            fontWeight: "bold",
                          },
                        }}
                      />

                       {/* newly added code */}
                       {/* <FormControl fullWidth>
                        <InputLabel> Select Role</InputLabel>
                        <Select
                          label="Select Role"
                          value={values.userRoleName}
                          onChange={handleChange}
                          name="userRoleName"
                          onBlur={handleBlur}
                          error={!!touched.userRoleName && !!errors.userRoleName}
                        >
                         <MenuItem value="ADMISSION_FEE">ADMISSION_FEE</MenuItem>
                          <MenuItem value="STORE_DEPARTMENT">STORE_DEPARTMENT</MenuItem>
                          <MenuItem value="EXAMINATION_CELL">EXAMINATION_CELL</MenuItem>
                          <MenuItem value="SCHEDULE_MEETING">SCHEDULE_MEETING</MenuItem>
                          <MenuItem value="HRBP">HRBP</MenuItem>
                          <MenuItem value="TRANSPORT">TRANSPORT</MenuItem>
                          
                          
                          
                          
                         
                        </Select>
                        {touched.userRoleName && errors.userRoleName && (
                          <Typography color="error" variant="body2">
                            {errors.userRoleName}
                          </Typography>
                        )}
                      </FormControl> */}


                      
                       {/* <FormControl fullWidth>
                        <InputLabel> Select Role</InputLabel>
                        <Select
                          label="Select Role"
                          value={values.userRoleName}
                          onChange={handleChange}
                          name="userRoleName"
                          onBlur={handleBlur}
                          error={!!touched.userRoleName && !!errors.userRoleName}
                        >
                          {(feature === "LITE") &&(
                            <>
                          <MenuItem value="ADMISSION_FEE">ADMISSION_FEE</MenuItem>
                          <MenuItem value="HRBP">HRBP</MenuItem>
                          <MenuItem value="SCHEDULE_MEETING">SCHEDULE_MEETING</MenuItem>
                          <MenuItem value="EXAMINATION_CELL">EXAMINATION_CELL</MenuItem>
                          
                          </>
                        )}
                         {(feature === "CORE") &&(
                            <>
                          <MenuItem value="ADMISSION_FEE">ADMISSION_FEE</MenuItem>
                          <MenuItem value="HRBP">HRBP</MenuItem>
                          <MenuItem value="TRANSPORT">TRANSPORT</MenuItem>
                          <MenuItem value="STORE_DEPARTMENT">STORE_DEPARTMENT</MenuItem>
                          <MenuItem value="EXAMINATION_CELL">EXAMINATION_CELL</MenuItem>
                          <MenuItem value="SCHEDULE_MEETING">SCHEDULE_MEETING</MenuItem>
                          
                          
                          </>
                        )}
                         {(feature === "ULTRA") &&(
                            <>
                          <MenuItem value="ADMISSION_FEE">ADMISSION_FEE</MenuItem>
                          <MenuItem value="STORE_DEPARTMENT">STORE_DEPARTMENT</MenuItem>
                          <MenuItem value="EXAMINATION_CELL">EXAMINATION_CELL</MenuItem>
                          <MenuItem value="SCHEDULE_MEETING">SCHEDULE_MEETING</MenuItem>
                          <MenuItem value="HRBP">HRBP</MenuItem>
                          <MenuItem value="TRANSPORT">TRANSPORT</MenuItem>
                          </>
                        )}
                          
                          
                          
                          
                         
                        </Select>
                        {touched.userRoleName && errors.userRoleName && (
                          <Typography color="error" variant="body2">
                            {errors.userRoleName}
                          </Typography>
                        )}
                      </FormControl> */}
                   <FormControl fullWidth>
  <InputLabel>Select Role*</InputLabel>
  <Select
    label="Select Role*"
    value={values.userRoleName}
    onChange={handleChange}
    name="userRoleName"
    onBlur={handleBlur}
    error={!!touched.userRoleName && !!errors.userRoleName}
  >
    {visibleRoles.map((role) => (
      <MenuItem key={role.value} value={role.value}>
        {role.label}
      </MenuItem>
    ))}
  </Select>
  {touched.userRoleName && errors.userRoleName && (
    <Typography color="error" variant="body2">
      {errors.userRoleName}
    </Typography>
  )}
</FormControl>




                    <StyledTextField
                        fullWidth
                        type="text"
                        label="First Name*"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const upperCaseValue = e.target.value.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.firstName}
                        name="firstName"
                        autoComplete="off"
                        error={!!touched.firstName && !!errors.firstName}
                        helperText={touched.firstName && errors.firstName}
                      />

                     
                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Last Name*"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const upperCaseValue = e.target.value.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.lastName}
                        name="lastName"
                        autoComplete="off"
                        error={!!touched.lastName && !!errors.lastName}
                        helperText={touched.lastName && errors.lastName}
                      />
                      
                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Contact Number"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.contactNumber}
                        name="contactNumber"
                        autoComplete="off"
                        // error={
                        //   !!touched.contactNumber && !!errors.contactNumber
                        // }
                        // helperText={
                        //   touched.contactNumber && errors.contactNumber
                        // }
                      />

<StyledTextField
                        fullWidth
                        type="file"
                        InputLabelProps={{ shrink: true }}
                        label="PassPhoto (JPG/JPEG/PNG)"
                        onBlur={handleBlur}
                        onChange={(e) =>
                          setFieldValue("profileUser", e.currentTarget.files[0])
                        }
                        name="profileUser"
                        error={!!touched.profileUser && !!errors.profileUser}
                        helperText={touched.profileUser && errors.profileUser}
                      />
                      

                     
                   


                        {false && (
                          <StyledTextField
                            fullWidth
                            type="text"
                            label="USER ROLE"
                            value="STAFF_LOGIN_USERS" // Fixed value
                            name="role"
                            InputProps={{
                              readOnly: true, // Makes the field non-editable
                              style: {
                                backgroundColor: "#f5f5f5",
                                color: "#888888",
                              },
                            }}
                            error={!!touched.role && !!errors.role}
                            helperText={touched.role && errors.role}
                          />
                        )}


                    </Box>
                    <Box
                      display="flex"
                      justifyContent="flex-end"
                      marginTop={3}
                    >
                      
                      <StyledButton
                        type="submit"
                        variant="contained"
                       
                        style={{ 
                          width: "130px",
                          backgroundColor: "#3C3972",
                          color: "white",
                         
                          "&:hover": {
                            backgroundColor: "#3C3972",
                          },
                        }}
                        disabled={loading}
                        onClick={async (e) => {
                          e.preventDefault(); // Prevent default form submission
                          setTouched({
                            firstName: true,
                            lastName: true,
                            emailId: true,
                            // contactNumber: true,
                            // role: true,
                            userRoleName:true,
                            // profilePic: true,
                            
                          });
                          
                          // Trigger form validation
                          const errors = await validateForm();
                          
                          if (Object.keys(errors).length === 0) {
                            // No errors, submit the form
                            handleSubmit(values); // Ensure values are passed
                          }
                        }}
                      >
                        {loading ? (
                          <FacebookCircularProgress size={24} sx={{ color: "#fff" }} />
                        ) : (
                          "Submit The Form"
                        )}
                      </StyledButton>
                    </Box>
                  </Box>
                )}
              </Card>
              <ToastContainer/>

            </Box>
          </form>
        )}
        
      </Formik>
      
    </Box>
  );
};

export default PrincipalRoleRegistrations;